/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */

const createSourceData = (type, title, data) => `<div class="source_container">
    <h4 class="source_title">${type}: ${title}</h4>
        ${data}
</div>`;

export default (type, title, description) => {
	if (type && title && typeof window !== 'undefined' && window.__INITIAL_STATE__.cms.modules.isInteractivePage) {
		const sourcesElement = document.querySelector('.sources__wrapper');
		if (!window.articleTitlePrepended && sourcesElement) {
			window.articleTitlePrepended = true;
			sourcesElement.innerHTML = `<h4 class="source_title">Article: ${window.document.title}</h4>${sourcesElement.innerHTML}`;
		}

		const sourcesData = createSourceData(type, title, description);
		const tempEl = document.createElement('div');
		tempEl.innerHTML = sourcesData;
		if (sourcesElement) {
			sourcesElement.append(tempEl.firstChild);
		}
	}
};
